import { fmtINR, fmtNum, fmtRate } from "@/lib/format";
import { GoalCard } from "./GoalCard";
import { SectionHead } from "./MetricTable";

const Kpi = ({ label, value, sub, testid }) => (
  <div className="rounded-2xl border border-slate-800 bg-slate-900 p-4">
    <p className="text-[11px] font-semibold uppercase tracking-wider text-slate-400">{label}</p>
    <p data-testid={testid} className="mt-1 font-mono text-lg font-semibold text-slate-50 sm:text-xl">{value}</p>
    {sub && <p data-testid={`${testid}-sub`} className="text-xs text-slate-400">{sub}</p>}
  </div>
);

const Commissions = ({ rows }) => (
  <div className="overflow-x-auto rounded-2xl border border-slate-800 bg-slate-900" data-testid="commissions-table">
    <table className="log-table">
      <thead><tr><th className="log-first">Rep</th><th className="text-right">As setter</th><th className="text-right">As closer</th><th className="text-right">Total (net)</th></tr></thead>
      <tbody>
        {rows.map((r) => (
          <tr key={r.rep_id} data-testid={`commission-row-${r.rep_id}`}>
            <td className="log-first font-semibold text-slate-50">{r.name}</td>
            <td className="text-right font-mono">{fmtINR(r.setter_earnings)}</td>
            <td className="text-right font-mono">{fmtINR(r.closer_earnings)}</td>
            <td data-testid={`commission-total-${r.rep_id}`} className={`text-right font-mono font-semibold ${r.total < 0 ? "text-amber-400" : "text-slate-50"}`}>{fmtINR(r.total)}</td>
          </tr>
        ))}
        {rows.length === 0 && <tr><td colSpan={4} className="text-center text-slate-500">No commissions in this range</td></tr>}
      </tbody>
    </table>
  </div>
);

export const MoneySection = ({ data, onGoalSaved }) => {
  const m = data.money;
  return (
    <section data-testid="money-section" className="space-y-3">
      <SectionHead title="Money" sub="Revenue Generated = Cash Collected. Net Revenue = Cash − Refunds." />
      <div className="grid grid-cols-1 gap-3 lg:grid-cols-3">
        <div className="grid grid-cols-2 gap-3 lg:col-span-2 xl:grid-cols-4">
          <Kpi testid="money-deposits" label="Deposits" value={fmtINR(m.deposits_sum)} sub={`${m.deposits_count} deposits`} />
          <Kpi testid="money-total-sales" label="Total Sales" value={fmtINR(m.total_sales_value)} sub={`${m.total_sales_count} won deals`} />
          <Kpi testid="money-revenue" label="Revenue Generated" value={fmtINR(m.revenue_generated)} />
          <Kpi testid="money-cash" label="Cash Collected" value={fmtINR(m.cash_collected)} />
          <Kpi testid="money-deposit-pif" label="Deposit → Paid In Full" value={fmtRate(m.deposit_to_pif_pct)} />
          <Kpi testid="money-days-to-collect" label="Avg Days to Collect" value={m.avg_days_to_collect === null ? "—" : `${fmtNum(m.avg_days_to_collect)}d`} />
          <Kpi testid="money-refunds" label="Refunds / Clawbacks" value={fmtINR(m.refunds)} />
          <Kpi testid="money-net-revenue" label="Net Revenue" value={fmtINR(m.net_revenue)} />
        </div>
        <GoalCard goal={data.goal} onSaved={onGoalSaved} />
      </div>
      <h3 className="section-title pt-2">Commissions earned (net of clawbacks)</h3>
      <Commissions rows={data.commissions} />
    </section>
  );
};
